import {Link} from "react-router-dom";
import routes from "../../Constants/routes";
import React from "react";
import {useTranslation} from "react-i18next";
import useSortingAndFiltering from "../../Hooks/useSortingAndFiltering";

const COLUMN_KEYS = {
    CREATE_DATE: "createDate",
    ACTION: "action",
    DESCRIPTION: "description",
    SALES_PERSON_NAME: "salesPersonName"
};

export const SkynetLogResults = ({logs }) => {
    const { t } = useTranslation();
    
    const defaultComparer = (a, b) => {
        // Default sort by createDate descending
        const aDate = new Date(a[COLUMN_KEYS.CREATE_DATE]).getTime();
        const bDate = new Date(b[COLUMN_KEYS.CREATE_DATE]).getTime();
        return bDate - aDate;
    };
    
    const { filteredAndSortedList, handleSortChange, getSortIcon } = useSortingAndFiltering({
        list: logs,
        searchText: "",
        searchableKeys: [COLUMN_KEYS.ACTION, COLUMN_KEYS.DESCRIPTION, COLUMN_KEYS.SALES_PERSON_NAME],
        defaultComparer
    });
    
    return (
        <table className="table table-stripe table-actionLogs">
            <thead>
            <tr
                style={{ cursor: 'pointer', userSelect: 'none' }}>
                <th 
                    className="text-left" 
                    onClick={() => handleSortChange(COLUMN_KEYS.CREATE_DATE)}
                >
                    {t('actionlogcontainer.time')}{getSortIcon(COLUMN_KEYS.CREATE_DATE)}
                </th>
                <th 
                    className="text-left" 
                    onClick={() => handleSortChange(COLUMN_KEYS.ACTION)}
                >
                    {t('activitylogtable.event')}{getSortIcon(COLUMN_KEYS.ACTION)}
                </th>
                <th 
                    className="text-left" 
                    onClick={() => handleSortChange(COLUMN_KEYS.DESCRIPTION)}
                >
                    {t('actionlogcontainer.description')}{getSortIcon(COLUMN_KEYS.DESCRIPTION)}
                </th>
                <th 
                    className="text-left" 
                    onClick={() => handleSortChange(COLUMN_KEYS.SALES_PERSON_NAME)}
                >
                    {t('loggingContainer.performedBy')}{getSortIcon(COLUMN_KEYS.SALES_PERSON_NAME)}
                </th>
            </tr>
            </thead>
            <tbody>
            {filteredAndSortedList?.length > 0 ? (
                filteredAndSortedList.map((log, index) => {
                    return <tr key={index}>
                        <td>{log.createDate}</td>
                        {log.emailActionLogId && !log.hideEmailLink
                            ?
                            <td><Link to={routes.emailHistory(log.emailActionLogId)}>{log.action}</Link>
                            </td>
                            : <td>{log.action}</td>}
                        <td>{log.description}</td>
                        <td>{log.salesPersonName}</td>
                    </tr>
                })
            ) : (
                <tr>
                    <td colSpan={4}>{t('actionlogcontainer.noentriesfound')}</td>
                </tr>
            )}
            </tbody>
        </table>
    )
}